import { MaskText } from "./motion";

export default function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section data-testid="page-header" className="relative pt-[76px] overflow-hidden bg-brand-ink text-brand-cream">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/70 to-brand-ink/40" />
        </div>
      )}
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-16">
        {eyebrow && <p className="text-xs uppercase tracking-[0.28em] text-brand-accent mb-5">{eyebrow}</p>}
        <MaskText lines={[title]} className="font-serif text-4xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight" />
        {subtitle && <p className="mt-6 max-w-2xl text-brand-cream/75 text-base sm:text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
